import { mutate } from "swr";
import type { SWRConfiguration } from "swr";

import { apiClient } from "@/lib/apiClient";

/** Default fetcher: an SWR key is the API endpoint to GET. */
export const fetcher = <T>(endpoint: string): Promise<T> => apiClient.get<T>(endpoint);

export const swrConfig: SWRConfiguration = {
  fetcher,
  revalidateOnFocus: false,
  shouldRetryOnError: false,
};

export function toErrorMessage(error: unknown): string | null {
  if (!error) return null;
  return error instanceof Error ? error.message : String(error);
}

/**
 * A write rarely touches one list: deleting a product also moves the recipes
 * and every stock it appeared in. Caches are matched by key prefix so detail
 * keys like `product-stocks/<id>` go stale with their listing.
 */
export function revalidate(...prefixes: string[]): Promise<unknown> {
  return mutate((key) => typeof key === "string" && prefixes.some((prefix) => key.startsWith(prefix)));
}
